import React from 'react';
import {connect} from 'react-redux';
import { Dropdown, DropdownMenu, DropdownToggle,DropdownItem } from 'reactstrap';
import Selector from 'react-year-month-selector';
import ReactQueryParams from 'react-query-params';
import * as TextManager from "../modules/languages/TextManager";

import moment from 'moment';

import {fetchSalesStatsDataIfNeeded} from '../redux/actions/SalesStatsActions'
/*import {fetchAffMarketingAssetsDataIfNeeded} from "../redux/actions/AffMarketingAssetsActions";
import {fetchOffersDataIfNeeded} from "../redux/actions/OffersActions";
import {fetchAccountsReportDataIfNeeded} from '../redux/actions/AccountsReportActions'
import {fetchAffiliateCommissionDataIfNeeded} from "../redux/actions/AffiliateCommissionActions";
import {fetchAffAccountsReportDataIfNeeded} from '../redux/actions/AffiliateAccountsReportActions'
import {fetchAffiliateStatsDataIfNeeded} from "../redux/actions/AffiliateStatsActions";
import {fetchPredictionDataIfNeeded} from "../redux/actions/PredictionActions"*/

const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];

class YearMonthSelector extends ReactQueryParams {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false,
            //startDate: moment(),
            isOpen: false,
            openFrom: false,
            openTo: false,
            startDate: "",
            endDate: "",
            items:[
                //{key:'this_month',value: TextManager.getCurrentTextResource().Utils.Date.this_month},
                {key:'last_month',value: TextManager.getCurrentTextResource().Utils.Date.last_month}
            ],
        };
    }

    componentDidMount() {
        /*if(this.props.lifetime) {
            let tmp = this.state.items.slice();
            tmp.push({key:'life_time',value: TextManager.getCurrentTextResource().Utils.Date.life_time});

            this.setState({items: tmp})
        }*/
    }

    setStart = (year, month) => {
        let tmp = monthNames[month] + ", "  + year;
        this.setState({startDate: tmp});
    };

    /*setEnd = (year, month) => {
        let tmp = monthNames[month] + ", "  + year;
        this.setState({endDate: tmp});
    };*/

    customRange = () => {

        if(this.state.startDate !== null) { // && this.state.endDate !== null) {
            let date1 = moment(new Date(this.state.startDate));
            //let date2 = moment(new Date(this.state.endDate)).endOf('month');
            this.setQueryParams({
                date: 'custom',
                startDate: date1.format('YYYY-MM-DD')+"T00:00:00Z",
                endDate: "" //date2.format('YYYY-MM-DD')+"T00:00:00Z"
            });

            if(this.props.endpoint === "sales_stats") {
                this.props.dispatch(fetchSalesStatsDataIfNeeded(this.queryParams));
            }
            /*else if(this.props.endpoint === "dashboard"){
                this.props.dispatch(fetchMainDashboardDataIfNeeded(this.queryParams));
            }
            */

            this.setState({startDate: "", endDate: ""})
        }
    };

    toggle() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
            openFrom: false,
            openTo: false,
        });
    }

    chooseItem(id){
        this.setQueryParams({
            date: id,
            startDate: '',
            endDate: ''
        });

        if(this.props.endpoint === "sales_stats") {
            this.props.dispatch(fetchSalesStatsDataIfNeeded(this.queryParams));
        }
        /*else if(this.props.endpoint === "dashboard"){
            this.props.dispatch(fetchMainDashboardDataIfNeeded(this.queryParams));
        }
        */
    }

    render() {
        var date = this.queryParams.date;
        if (!date){
            if(this.props.default) {
                date = this.props.default;
            }
            else {
                date = 'last_month'; //'this_month';
            }
        }

        let dateName;

        if(date !== 'custom') {
            for (var dateIndex in this.state.items) {
                if (this.state.items[dateIndex].key === date) {
                    dateName = this.state.items[dateIndex].value;
                }
            }
        }
        else {
            let start = this.queryParams.startDate;
            //let end = this.queryParams.endDate;

            start = start.split('T')[0];
            //end = end.split('T')[0];

            dateName = start; // + " / " + end;
        }

        return (
            <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle}>
                <DropdownToggle
                    className="icon icon--right btn btn-outline-primary btn-sm"
                    tag="span"
                    onClick={this.toggle}
                    data-toggle="dropdown"
                    aria-expanded={this.state.dropdownOpen}
                >
                    <p>
                        {dateName}
                        <svg width="24" height="24" viewBox="0 0 24 24" className="mdi-icon">
                            <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"></path>
                        </svg>
                    </p>

                </DropdownToggle>
                <DropdownMenu className='dropdown__menu'>

                    {this.state.items.map((currItem, index) =>
                        <DropdownItem key={index} onClick={() => this.chooseItem(currItem.key)}>
                            {currItem.value}
                        </DropdownItem>
                    )}

                    <DropdownItem divider/>

                    <div className='date-picker date-picker--interval' style={{padding: 0, marginLeft: '10px'}}>
                        <input
                            placeholder={TextManager.getCurrentTextResource().Utils.from}
                            onClick={() => this.setState({openFrom: !this.state.openFrom})}
                            style={{width: '130px'}}
                            value={this.state.startDate}
                        />
                    </div>

                    <div className='date-picker date-picker--interval' style={{padding: 0}}>
                        <style>
                            {`
                                .ryms-container  {
                                  width:100%;
                                }
                            `}
                        </style>
                        <Selector
                            key='from'
                            year={2021}
                            month={10}
                            open={this.state.openFrom}
                            onClose={() => this.setState({openFrom: !this.state.openFrom})}
                            onChange={(year, month)=> this.setStart(year, month)}
                        />
                    </div>

                    {/*<div className='date-picker date-picker--interval' style={{paddingTop: '1em'}}>
                        <input placeholder={TextManager.getCurrentTextResource().Utils.to}
                               onClick={() => this.setState({openTo: !this.state.openTo})}
                               style={{width: '130px'}}
                               value={this.state.endDate}
                        />
                    </div>

                    <div className='date-picker date-picker--interval' style={{padding: 0}}>
                        <Selector
                            key='from'
                            year={2019}
                            month={1}
                            open={this.state.openTo}
                            onClose={() => this.setState({openTo: !this.state.openTo})}
                            onChange={(year, month)=> this.setEnd(year, month)}
                        />
                    </div>*/}

                    <DropdownItem key='1000' onClick={() => this.customRange()} style={{marginTop: '1em'}}>
                        {TextManager.getCurrentTextResource().Utils.apply}
                    </DropdownItem>

                </DropdownMenu>
            </Dropdown>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        date: state.mainDashboard.date
    };
};

export default connect(mapStateToProps)(YearMonthSelector);